export default __webpack_public_path__ + "static/og-image-b29b89f741273f619429a81d3ecd2df6.png";